
export class UserLoginEntitie {
    constructor({
        userId,
        email,
        mainPlanet,
        token,
        mercureToken
    }) {
        this.userId = userId;
        this.email = email;
        this.mainPlanet = mainPlanet;
        this.token = `Bearer ${token}`;
        this.mercureToken = `Bearer ${mercureToken}`;
    }

    static fromJSON(json) {
        return new UserLoginEntitie(json);
    }
}